import { defineComponent as _defineComponent } from 'vue'
import { HouseDesignInterface } from "@/types/HouseDesignInterface";
  import BuilderEstimatorHouseFeaturesMobile from "./house-features/BuilderEstimatorHouseFeaturesMobile.vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderEstimatorHouseHeaderMobile',
  props: {
    houseName: {},
    features: {}
  },
  emits: ["back"],
  setup(__props: any, { expose: __expose }) {
  __expose();

  

  

const __returned__ = { get HouseDesignInterface() { return HouseDesignInterface }, BuilderEstimatorHouseFeaturesMobile }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})